document.addEventListener('DOMContentLoaded', function () {
  // Store all swiper instances
  const swiperInstances = {
    outer: {},
    main: {},
    thumb: {}
  };
  const defaultMoneyFormat = (window.Shopify && window.Shopify.money_format) || window.moneyFormat || '${{amount}}';
  
  function formatMoneyValue(value) {
    if (typeof window.Shopify !== 'undefined' && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(value, defaultMoneyFormat);
    }
    return (Number(value || 0) / 100).toFixed(2);
  }
  
  function buildVariantMetaFromProduct(product) {
    const meta = {};
    if (!product || !Array.isArray(product.variants)) {
      return meta;
    }
    product.variants.forEach(variant => {
      meta[String(variant.id)] = {
        formatted_price: formatMoneyValue(variant.price || 0),
        url: product.url ? `${product.url}?variant=${variant.id}` : (variant.url || '')
      };
    });
    return meta;
  }
  
  function parseJsonFromScript(scriptEl) {
    if (!scriptEl) return null;
    try {
      return JSON.parse(scriptEl.textContent);
    } catch (error) {
      console.warn('JSON parse error', error);
      return null;
    }
  }
  
  function preloadImages(imageList = []) {
    const loaders = imageList.map((img) => {
      return new Promise((resolve) => {
        const image = new Image();
        image.onload = () => resolve();
        image.onerror = () => resolve();
        image.src = img.src;
      });
    });
    return Promise.all(loaders);
  }

  // Initialize tab functionality
  function initTabs() {
    const tabButtons = document.querySelectorAll('.tab-button');
    const tabContents = document.querySelectorAll('.tab-content-wrapper');
    tabButtons.forEach(button => {
      button.addEventListener('click', function() {
        const tabId = this.getAttribute('data-tab-id');
        
        // Remove active class from all buttons and contents
        tabButtons.forEach(btn => btn.classList.remove('g-active'));
        tabContents.forEach(content => {
          content.classList.remove('active');
        });
        
        // Add active class to clicked button and corresponding content
        tabButtons.forEach(btn => {
          if (btn.getAttribute('data-tab-id') === tabId) {
            btn.classList.add('g-active');
            btn.setAttribute('aria-checked', 'true');
          } else {
            btn.setAttribute('aria-checked', 'false');
          }
        });
        const targetContent = document.querySelector(`.tab-content-wrapper[data-tab-id="${tabId}"]`);
        if (targetContent) {
          // Trigger fade-in by adding active class
          // Use requestAnimationFrame to ensure the display change happens before fade-in
          requestAnimationFrame(() => {
            targetContent.classList.add('active');
          });
        }
        // Reinitialize swipers for the active tab
        setTimeout(() => {
          initOuterSliders();
          initAllProductDisplays();
        }, 100);
      });
    });
  }

  // Initialize outer slider (for multiple products in a tab)
  function initOuterSliders() {
    const outerSwipers = document.querySelectorAll('.outer-product-swiper');
    
    outerSwipers.forEach(swiperEl => {
      const tabId = swiperEl.getAttribute('data-tab-id');
      const tabContent = swiperEl.closest('.tab-content-wrapper');
      
      // Only initialize if the tab is active
      if (!tabContent.classList.contains('active')) return;
      
      // Destroy existing instance if it exists
      if (swiperInstances.outer[tabId]) {
        swiperInstances.outer[tabId].destroy(true, true);
      }
      
      // Initialize new swiper
      swiperInstances.outer[tabId] = new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        navigation: {
          nextEl: `.outer-next-${tabId}`,
          prevEl: `.outer-prev-${tabId}`
        },
        mousewheel: {
          enabled: true,
          forceToAxis: true,
          sensitivity: 1,
          releaseOnEdges: false,
     
        },
        on: {
          init: function() {
            const prevBtn = document.querySelector(`.outer-prev-${tabId}`);
            const nextBtn = document.querySelector(`.outer-next-${tabId}`);
            if (prevBtn) prevBtn.setAttribute('aria-label', 'Previous product');
            if (nextBtn) nextBtn.setAttribute('aria-label', 'Next product');
            setTimeout(function() {
              if (prevBtn) prevBtn.setAttribute('aria-label', 'Previous product');
              if (nextBtn) nextBtn.setAttribute('aria-label', 'Next product');
            }, 0);
            updateOuterCarouselSlideAria(this);
          },
          slideChange: function() {
            updateOuterCarouselSlideAria(this);
            // Reinitialize inner swipers when outer slide changes
            setTimeout(() => {
              initAllProductDisplays();
            }, 100);
          }
        }
      });

      function updateOuterCarouselSlideAria(swiper) {
        if (!swiper || !swiper.slides || !swiper.slides.length) return;
        const total = swiper.slides.length;
        const activeIndex = swiper.realIndex != null ? swiper.realIndex : swiper.activeIndex;
        swiper.slides.forEach((slide, i) => {
          const isActive = i === activeIndex;
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          slide.setAttribute('role', 'group');
          slide.setAttribute('aria-roledescription', 'slide');
          slide.setAttribute('aria-label', 'Product ' + (i + 1) + ' of ' + total);
        });
      }
    const outerPrevBtn = document.querySelector(`.outer-prev-${tabId}`);
    const outerNextBtn = document.querySelector(`.outer-next-${tabId}`);
    if (outerPrevBtn) outerPrevBtn.setAttribute('aria-label', 'Previous product');
    if (outerNextBtn) outerNextBtn.setAttribute('aria-label', 'Next product');
    });
  }

  // Initialize all product displays (variant selection and image sliders)
  function initAllProductDisplays() {
    // Find all active product containers
    const activeTab = document.querySelector('.tab-content-wrapper.active');
    if (!activeTab) return;
    
    const productContainers = activeTab.querySelectorAll('[data-product-container]');
    
    productContainers.forEach(container => {
      const productId = container.getAttribute('data-product-container');
      
      // Only initialize visible products (in case of outer slider)
      const parentSlide = container.closest('.swiper-slide');
      if (parentSlide && !parentSlide.classList.contains('swiper-slide-active')) {
        return; // Skip non-active slides
      }
      
      initProductDisplay(container, productId);
    });
  }

  // Initialize a single product display
  function initProductDisplay(container, productId) {
    // Get product JSON data
    const productJsonEl = container.querySelector(`[data-product-id="${productId}"].product-json`);
    const variantMetaEl = container.querySelector(`[data-product-id="${productId}"].variant-meta`);
    const linkedColorsEl = container.querySelector(`[data-product-id="${productId}"].linked-color-products`);
    
    if (!productJsonEl) return;
    
    const product = parseJsonFromScript(productJsonEl);
    const variantMeta = parseJsonFromScript(variantMetaEl) || buildVariantMetaFromProduct(product);
    const linkedColorProducts = parseJsonFromScript(linkedColorsEl) || [];
    
    if (!product) return;
    
    // Initialize image sliders
    initImageSliders(container, productId, product);
    
    // Initialize variant selection
    const variantController = initVariantSelection(container, productId, product, variantMeta);
    
    initLinkedColorProducts(container, productId, variantController, linkedColorProducts, product);
  }

    // Initialize image sliders (main and thumbnail)
  function initImageSliders(container, productId, product) {
    const mainSwiperEl = container.querySelector(`.mySwiper-${productId}`);
    const thumbSwiperEl = container.querySelector(`.mySwiper2-${productId}`);
    
    if (!mainSwiperEl || !thumbSwiperEl) return;
    
    // Destroy existing instances
    if (swiperInstances.thumb[productId]) {
      swiperInstances.thumb[productId].destroy(true, true);
    }
    if (swiperInstances.main[productId]) {
      swiperInstances.main[productId].destroy(true, true);
    }
    
    // Initialize thumbnail swiper first
    swiperInstances.thumb[productId] = new Swiper(thumbSwiperEl, {
      spaceBetween: 10,
      slidesPerView: 3,
      freeMode: true,
      watchSlidesProgress: true,
      mousewheel: {
        enabled: true,
        forceToAxis: true,
        sensitivity: 1,
        releaseOnEdges: false,
      }
    });
    
    // Determine navigation elements (guard for missing buttons)
    const prevButton = container.querySelector(`.main-prev-${productId}`);
    const nextButton = container.querySelector(`.main-next-${productId}`);
    const navigationConfig = {};
    if (prevButton) navigationConfig.prevEl = prevButton;
    if (nextButton) navigationConfig.nextEl = nextButton;
    
    // Update carousel slide ARIA (aria-hidden, aria-label) for accessibility
    function updateCarouselSlideAria(swiper) {
      if (!swiper || !swiper.slides || !swiper.slides.length) return;
      const total = swiper.slides.length;
      const activeIndex = swiper.realIndex != null ? swiper.realIndex : swiper.activeIndex;
      swiper.slides.forEach((slide, i) => {
        const isActive = i === activeIndex;
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        slide.setAttribute('role', 'group');
        slide.setAttribute('aria-roledescription', 'slide');
        slide.setAttribute('aria-label', 'Image ' + (i + 1) + ' of ' + total);
      });
    }

    // Initialize main swiper with thumbs
    swiperInstances.main[productId] = new Swiper(mainSwiperEl, {
      spaceBetween: 10,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      ...(Object.keys(navigationConfig).length ? { navigation: navigationConfig } : {}),
      mousewheel: {
        enabled: true,
        forceToAxis: true,
        sensitivity: 1,
        releaseOnEdges: false,
      },
      thumbs: {
        swiper: swiperInstances.thumb[productId]
      },
      on: {
        init: function () {
          if (prevButton) prevButton.setAttribute('aria-label', 'Previous image');
          if (nextButton) nextButton.setAttribute('aria-label', 'Next image');
          setTimeout(function () {
            if (prevButton) prevButton.setAttribute('aria-label', 'Previous image');
            if (nextButton) nextButton.setAttribute('aria-label', 'Next image');
          }, 0);
          updateCarouselSlideAria(this);
        },
        slideChange: function () {
          updateCarouselSlideAria(this);
        }
      }
    });
    if (prevButton) prevButton.setAttribute('aria-label', 'Previous image');
    if (nextButton) nextButton.setAttribute('aria-label', 'Next image');
  }

  // Initialize variant selection for a product
  function initVariantSelection(container, productId, initialProduct, initialVariantMeta) {
    const variantContainer = container.querySelector(`[data-variant-container="${productId}"]`);
    if (!variantContainer) return;
    
    const groups = variantContainer.querySelectorAll('.variant-option-group');
    const variantIdInputs = container.querySelectorAll('.variant-id-input');
    const addToCartButtons = container.querySelectorAll('.btn.btn-primary');
    const galleryEl = container.querySelector('.product-gallery');
    const mainSwiperSelector = `.mySwiper-${productId}`;
    let galleryHeightLocked = false;
    
    const getGalleryHeight = () => {
      if (!galleryEl) return 0;
      let height = galleryEl.getBoundingClientRect().height;
      if (height > 200) return height; // Only use if reasonable height
      const mainSwiperEl = galleryEl.querySelector(mainSwiperSelector);
      if (mainSwiperEl) {
        const swiperRect = mainSwiperEl.getBoundingClientRect();
        if (swiperRect.height > 200) return swiperRect.height;
        height = mainSwiperEl.scrollHeight;
        if (height > 200) return height;
      }
      const activeImage = galleryEl.querySelector(`${mainSwiperSelector} .swiper-slide-active img`);
      if (activeImage) {
        // Wait for image to load if not already loaded
        if (activeImage.complete && activeImage.naturalWidth > 0 && activeImage.naturalHeight > 0) {
          const width = activeImage.clientWidth || activeImage.naturalWidth || 0;
          const naturalWidth = activeImage.naturalWidth || 0;
          const naturalHeight = activeImage.naturalHeight || 0;
          if (naturalWidth > 0 && naturalHeight > 0) {
            const ratio = width > 0 ? width / naturalWidth : 1;
            const calculatedHeight = naturalHeight * ratio;
            if (calculatedHeight > 200) return calculatedHeight;
          }
        }
      }
      const scrollHeight = galleryEl.scrollHeight;
      return scrollHeight > 200 ? scrollHeight : 0;
    };
    
    const lockGalleryHeight = (skipIfSmall = true) => {
      if (!galleryEl || galleryHeightLocked) return false;
      const measuredHeight = getGalleryHeight();
      // Only lock if we have a reasonable height (prevent locking at 101px)
      if (measuredHeight > 200 || !skipIfSmall) {
        galleryEl.style.minHeight = `${measuredHeight}px`;
        galleryHeightLocked = true;
        return true;
      }
      return false;
    };
    
    const unlockGalleryHeight = () => {
      if (!galleryEl || !galleryHeightLocked) return;
      galleryEl.style.minHeight = '';
      galleryHeightLocked = false;
    };
    
    const colorOptionIndex = 0; // Assuming color is the first option
    const variantButtonsWrappers = variantContainer.querySelectorAll('[data-variant-buttons]');
    const colorHiddenButtons = variantContainer.querySelectorAll('[data-color-hidden-buttons] .variant-button');
    let activeProduct = initialProduct;
    let activeVariantMeta = initialVariantMeta;
    
    function rebuildVariantButtonsForProduct(productToUse) {
      if (!productToUse || !productToUse.options_with_values) return;
      
      variantButtonsWrappers.forEach(wrapper => {
        const group = wrapper.closest('.variant-option-group');
        if (!group) return;
        const optionIndex = Number(group.getAttribute('data-option-index'));
        if (optionIndex === colorOptionIndex) return;
        const optionName = group.getAttribute('data-option-name');
        const optionData = productToUse.options_with_values.find(opt => {
          if (opt.position) {
            return Number(opt.position) - 1 === optionIndex;
          }
          return opt.name === optionName;
        });
        if (!optionData) {
          wrapper.innerHTML = '';
          return;
        }
        const buttonsHtml = optionData.values
          .map(value => `<button type="button" class="variant-button" data-value="${value}" role="radio" aria-checked="false" aria-label="${value.replace(/"/g, '&quot;')}">${value}</button>`)
          .join('');
        wrapper.innerHTML = buttonsHtml;
      });
    }
    
    // Clear active only from Size (option 1), not from Width – Width stays preselected
    function clearNonColorSelections() {
      groups.forEach(group => {
        const optionIndex = group.getAttribute('data-option-index');
        if (optionIndex === '0') return;
        const label = group.querySelector('.vareint-title-product, [class*="vareint-title"]');
        const labelText = (label && label.textContent || '').toLowerCase();
        if (labelText.indexOf('width') !== -1) return;
        group.querySelectorAll('.variant-button').forEach(btn => {
          btn.classList.remove('active');
          btn.setAttribute('aria-checked', 'false');
        });
      });
    }

    function ensureWidthPreselected() {
      groups.forEach(group => {
        const label = group.querySelector('.vareint-title-product, [class*="vareint-title"]');
        const labelText = (label && label.textContent || '').toLowerCase();
        if (labelText.indexOf('width') === -1) return;
        const allInGroup = group.querySelectorAll('.variant-button');
        if (allInGroup.length === 0) return;
        const firstNonDisabled = group.querySelector('.variant-button:not(.disabled)');
        const targetBtn = firstNonDisabled || allInGroup[0];
        allInGroup.forEach(b => {
          b.classList.remove('active');
          b.setAttribute('aria-checked', 'false');
        });
        targetBtn.classList.add('active');
        targetBtn.setAttribute('aria-checked', 'true');
      });
    }
    
    rebuildVariantButtonsForProduct(activeProduct);
    
    function setActiveProductContext(newProduct, contextOptions = {}) {
      if (!newProduct) return;
      activeProduct = newProduct;
      activeVariantMeta = contextOptions.variantMeta || buildVariantMetaFromProduct(newProduct);
      rebuildVariantButtonsForProduct(activeProduct);
      clearNonColorSelections();
      ensureWidthPreselected();
      const overrides = contextOptions.selectionOverrides || {};
      return updateUIForVariant({
        selectionOverrides: overrides,
        sourceProduct: contextOptions.sourceProduct || newProduct,
        forceImageUpdate: contextOptions.forceImageUpdate,
        isInitialLoad: contextOptions.isInitialLoad || false
      });
    }
    // Get selected options from active buttons
    function getSelectedOptions(overrides = {}) {
      return Array.from(groups).map((g, index) => {
        if (Object.prototype.hasOwnProperty.call(overrides, index)) {
          return overrides[index];
        }
        const activeBtn = g.querySelector('.variant-button.active');
        return activeBtn ? activeBtn.getAttribute('data-value') : null;
      });
    }
    
    // Find variant by selected options (exact match)
    function findVariantByOptions(selectedOptions) {
      if (!activeProduct || !activeProduct.variants) return null;
      return activeProduct.variants.find(v => {
        if (Array.isArray(v.options)) {
          return v.options.every((opt, i) => opt === selectedOptions[i]);
        }
        if (selectedOptions.length === 1 && v.option1) return v.option1 === selectedOptions[0];
        if (selectedOptions.length === 2 && v.option1 && v.option2) {
          return v.option1 === selectedOptions[0] && v.option2 === selectedOptions[1];
        }
        if (selectedOptions.length === 3 && v.option1 && v.option2 && v.option3) {
          return v.option1 === selectedOptions[0] && v.option2 === selectedOptions[1] && v.option3 === selectedOptions[2];
        }
        return false;
      }) || null;
    }
    
    // Check if any variant exists with the given partial options (null values are ignored)
    function hasVariantWithOptions(testOptions) {
      if (!activeProduct || !activeProduct.variants) return false;
      return activeProduct.variants.some(v => {
        // Check each option position - if testOptions[i] is not null, it must match
        for (let i = 0; i < testOptions.length; i++) {
          if (testOptions[i] !== null && testOptions[i] !== undefined) {
            let variantOption = null;
            if (Array.isArray(v.options)) {
              variantOption = v.options[i];
            } else {
              if (i === 0) variantOption = v.option1;
              else if (i === 1) variantOption = v.option2;
              else if (i === 2) variantOption = v.option3;
            }
            if (variantOption !== testOptions[i]) {
              return false;
            }
          }
        }
        return true;
      });
    }
    
    // Check if all required options are selected (excluding Gender/Color - data-option-index="0")
    function areAllOptionsSelected() {
      const groupsArray = Array.from(groups);
      // Filter out groups with data-option-index="0" (Gender/Color)
      const groupsToCheck = groupsArray.filter(group => {
        const optionIndex = group.getAttribute('data-option-index');
        return optionIndex !== '0';
      });
      
      // If there are no groups to check (only Gender exists), return true
      if (groupsToCheck.length === 0) {
        return true;
      }
      
      // Check if all groups (except data-option-index="0") have an active button
      return groupsToCheck.every(group => {
        const buttons = group.querySelectorAll('.variant-button');
        if (buttons.length === 0) {
          return true; // If no buttons in group, consider it valid
        }
        return Array.from(buttons).some(btn => btn.classList.contains('active'));
      });
    }
    
    // Update disabled state of variant buttons based on current selections
    function updateVariantButtonStates() {
      const selectedOptions = getSelectedOptions();
      
      groups.forEach((group, groupIndex) => {
        const buttons = group.querySelectorAll('.variant-button');
        
        buttons.forEach(btn => {
          const btnValue = btn.getAttribute('data-value');
          const testOptions = [...selectedOptions];
          testOptions[groupIndex] = btnValue;
          
          // Check if any variant exists with this combination (partial match is OK)
          const hasVariant = hasVariantWithOptions(testOptions);
          
          if (hasVariant) {
            // Check if at least one variant with this combination is available
            const availableVariant = activeProduct.variants.find(v => {
              for (let i = 0; i < testOptions.length; i++) {
                if (testOptions[i] !== null && testOptions[i] !== undefined) {
                  let variantOption = null;
                  if (Array.isArray(v.options)) {
                    variantOption = v.options[i];
                  } else {
                    if (i === 0) variantOption = v.option1;
                    else if (i === 1) variantOption = v.option2;
                    else if (i === 2) variantOption = v.option3;
                  }
                  if (variantOption !== testOptions[i]) {
                    return false;
                  }
                }
              }
              return true;
            });
            
            if (availableVariant && availableVariant.available) {
              btn.classList.remove('disabled');
              btn.removeAttribute('disabled');
            } else {
              btn.classList.add('disabled');
            }
          } else {
            btn.classList.add('disabled');
            // Don't set disabled attribute - keep it clickable for visual indication only
          }
        });
      });
    }
    
    // Update UI based on selected variant
    function updateUIForVariant(options = {}) {
      const selectionOverrides = options.selectionOverrides || {};
      let selectedOptions = getSelectedOptions(selectionOverrides);
      let variant = findVariantByOptions(selectedOptions);
      
      // Update disabled states of variant buttons
      updateVariantButtonStates();
      ensureWidthPreselected();
      selectedOptions = getSelectedOptions(selectionOverrides);
      variant = findVariantByOptions(selectedOptions);
      
      // Check if all options are selected
      const allSelected = areAllOptionsSelected();
      
      if (variant && allSelected) {
        const vm = activeVariantMeta[String(variant.id)] || {};
        
        // Update variant ID in all forms
        variantIdInputs.forEach(input => {
          input.value = variant.id;
        });
        
        // Update add to cart button based on availability
        addToCartButtons.forEach(button => {
          if (variant.available) {
            button.textContent = 'Add to Cart';
            button.disabled = false;
            button.style.opacity = '1';
            button.style.cursor = 'pointer';
          } else {
            button.textContent = 'Sold Out';
            button.disabled = true;
            // button.style.opacity = '0.6';
            // button.style.cursor = 'not-allowed';
          }
        });
      } else {
        // No variant found or not all options selected - clear variant ID and disable button
        variantIdInputs.forEach(input => {
          input.value = '';
        });
        
        addToCartButtons.forEach(button => {
          if (!allSelected) {
            button.textContent = 'Add to Cart';
            button.disabled = false; // Keep enabled so validation can trigger
            button.style.opacity = '1';
            button.style.cursor = 'pointer';
          } else {
            button.textContent = 'Unavailable';
            button.disabled = true;
          }
        });
      }
      
      // Filter images by color (runs even if variant is null)
      // This ensures images are filtered based on color selection regardless of variant availability
      const color = selectedOptions[colorOptionIndex];
      if (color || options.forceImageUpdate) {
        return updateImageSlider(color, options.sourceProduct || activeProduct, options.forceImageUpdate, options.isInitialLoad || false);
      }
      return Promise.resolve();
    }
    
    // Read all images from product
    function readImagesFromProduct(sourceProduct = activeProduct) {
      const images = [];
      if (sourceProduct && Array.isArray(sourceProduct.media)) {
        sourceProduct.media.forEach(m => {
          const src = m.preview_image?.src || m.src || '';
          const alt = m.alt || '';
          if (src) images.push({ src, alt, media: m });
        });
      } else if (sourceProduct && Array.isArray(sourceProduct.images)) {
        sourceProduct.images.forEach(img => {
          if (typeof img === 'string') images.push({ src: img, alt: '', media: null });
          else images.push({ src: img.src || '', alt: img.alt || '', media: img });
        });
      }
      return images;
    }
    
    // Update image slider based on color selection
    function updateImageSlider(colorValue, sourceProduct = activeProduct, forceAll = false, isInitialLoad = false) {
      // On initial load, don't lock height to prevent 101px issue
      if (isInitialLoad) {
        // Ensure any previous lock is cleared
        unlockGalleryHeight();
      } else {
        // Lock height before changing images (color change)
        lockGalleryHeight();
      }
      
      const images = readImagesFromProduct(sourceProduct);
      const color = colorValue?.toLowerCase().trim() || '';
      const rebuild = (imageSet) => {
        return rebuildImageSlider(container, productId, imageSet, sourceProduct);
      };
      const prepareImages = (imageSet) => preloadImages(imageSet).catch(() => {});
      
      // Wait for images to load in DOM before calculating height
      const waitForImagesLoad = () => {
        return new Promise((resolve) => {
          const mainSwiperEl = galleryEl?.querySelector(mainSwiperSelector);
          if (!mainSwiperEl) {
            resolve();
            return;
          }
          const images = mainSwiperEl.querySelectorAll('img');
          if (images.length === 0) {
            resolve();
            return;
          }
          let loadedCount = 0;
          const checkComplete = () => {
            loadedCount++;
            if (loadedCount >= images.length) {
              // Wait for layout to settle
              requestAnimationFrame(() => {
                requestAnimationFrame(resolve);
              });
            }
          };
          images.forEach(img => {
            if (img.complete && img.naturalHeight > 0) {
              checkComplete();
            } else {
              img.addEventListener('load', checkComplete, { once: true });
              img.addEventListener('error', checkComplete, { once: true });
            }
          });
          // Timeout fallback
          setTimeout(resolve, 2000);
        });
      };
      
      const processImages = (imageSet) => {
        return prepareImages(imageSet)
          .then(() => rebuild(imageSet))
          .then(() => {
            if (!isInitialLoad) {
              // Wait for images to load, then unlock and re-lock with correct height
              return waitForImagesLoad().then(() => {
                unlockGalleryHeight();
                lockGalleryHeight();
              });
            } else {
              // On initial load, just wait for images to ensure proper rendering
              return waitForImagesLoad();
            }
          });
      };
      
      if (forceAll) {
        return processImages(images);
      }
      
      if (!color) {
        // No color selected, show only common images (no prefix)
        const commonImages = images.filter(img => {
          const alt = img.alt?.toLowerCase().trim() || '';
          return !alt.startsWith('home_') && !alt.startsWith('pdp_');
        });
        const finalImages = commonImages.length > 0 ? commonImages : images;
        return processImages(finalImages);
      }
      
      // Filter images for home page:
      // Include: home_colorname and colorname (common)
      // Exclude: pdp_colorname
      const matched = images.filter(img => {
        const alt = img.alt?.toLowerCase().trim() || '';
        
        // Check if it's a home-specific image (home_colorname)
        if (alt === `home_${color}`) {
          return true;
        }
        
        // Check if it's a common image (colorname without prefix)
        if (alt === color) {
          return true;
        }
        
        // Exclude pdp images
        return false;
      });
      
      // If no images match, show only common images (no home_ or pdp_ prefix)
      if (matched.length === 0) {
        const commonImages = images.filter(img => {
          const alt = img.alt?.toLowerCase().trim() || '';
          return !alt.startsWith('home_') && !alt.startsWith('pdp_');
        });
        const finalImages = commonImages.length > 0 ? commonImages : images;
        return processImages(finalImages);
      } else {
        return processImages(matched);
      }
    }
    
    // Build HTML for slides
    function buildSlidesHtml(images) {
      return images.map(img => {
        return `<div class="swiper-slide"><img src="${img.src}" alt="${img.alt}" class="main-swiper-image" width="600" height="auto" loading="lazy"></div>`;
      }).join('');
    }
    
    function buildThumbSlidesHtml(images) {
      return images.map(img => {
        return `<div class="swiper-slide"><img src="${img.src}" alt="${img.alt}" width="150" height="auto" loading="lazy"></div>`;
      }).join('');
    }
    
    // Rebuild image slider with new images
    function rebuildImageSlider(container, productId, images, sourceProduct = activeProduct) {
      const mainWrapper = container.querySelector(`.mySwiper-${productId} .swiper-wrapper`);
      const thumbWrapper = container.querySelector(`.mySwiper2-${productId} .swiper-wrapper`);
      
      if (!mainWrapper || !thumbWrapper) return;
      
      // Update HTML with filtered images
      mainWrapper.innerHTML = buildSlidesHtml(images);
      thumbWrapper.innerHTML = buildThumbSlidesHtml(images);
      
      // Reinitialize swipers with filtered images
      initImageSliders(container, productId, sourceProduct);
      return new Promise((resolve) => {
        requestAnimationFrame(() => {
          requestAnimationFrame(resolve);
        });
      });
    }
    
    // Show popup message for missing selections (only once per product per validation attempt)
    function showSelectionPopup(productContainer) {
      // Use data attribute to track if popup was shown for this product
      const popupShown = productContainer.getAttribute('data-popup-shown');
      if (popupShown === 'true') {
        return;
      }
      
      productContainer.setAttribute('data-popup-shown', 'true');
      
      // Show modal instead of alert
      if (window.SelectionRequiredModal && typeof window.SelectionRequiredModal.open === 'function') {
        window.SelectionRequiredModal.open();
        
        // Reset flag after modal is closed
        const modal = document.querySelector('.pahi-selection-modal');
        if (modal) {
          const handleClose = () => {
            productContainer.removeAttribute('data-popup-shown');
            modal.removeEventListener('transitionend', handleClose);
          };
          // Wait for modal close animation
          setTimeout(() => {
            productContainer.removeAttribute('data-popup-shown');
          }, 500);
        }
      } else {
        // Fallback to alert if modal is not available
        alert('Please select Size and Width before adding to cart.');
        setTimeout(() => {
          productContainer.removeAttribute('data-popup-shown');
        }, 100);
      }
    }
    
    // Bind form submissions to validate selections
    const addToCartForms = container.querySelectorAll('.add-to-cart-form');
    addToCartForms.forEach(form => {
      form.addEventListener('submit', (e) => {
        // Find the product container that contains this form
        const productContainer = form.closest('[data-product-container]');
        if (!productContainer) {
          return;
        }
        
        // Check if this container is in the active tab
        const activeTab = document.querySelector('.tab-content-wrapper.active');
        if (!activeTab || !activeTab.contains(productContainer)) {
          return; // Not in active tab, skip validation
        }
        
        // Check if this container is in the active slider slide (if it's in a slider)
        const parentSlide = productContainer.closest('.swiper-slide');
        if (parentSlide && !parentSlide.classList.contains('swiper-slide-active')) {
          return; // Not in active slide, skip validation
        }
        
        // Get variant container for this specific product
        const productVariantContainer = productContainer.querySelector(`[data-variant-container="${productId}"]`);
        if (!productVariantContainer) {
          return;
        }
        
        // Re-query groups for this specific product container
        const currentGroups = productVariantContainer.querySelectorAll('.variant-option-group');
        
        // Filter out groups with data-option-index="0" (Gender/Color)
        const groupsToCheck = Array.from(currentGroups).filter(group => {
          const optionIndex = group.getAttribute('data-option-index');
          return optionIndex !== '0';
        });
        
        // Check if all required groups have an active selection
        const allSelected = groupsToCheck.length === 0 || groupsToCheck.every(group => {
          const buttons = group.querySelectorAll('.variant-button');
          if (buttons.length === 0) return true;
          return Array.from(buttons).some(btn => btn.classList.contains('active'));
        });
        
        if (!allSelected) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation(); // Prevent other handlers
          showSelectionPopup(productContainer);
          return false;
        }
      }, true); // Use capture phase to handle early
    });
    
    variantContainer.addEventListener('click', (event) => {
      const targetButton = event.target.closest('.variant-button');
      if (!targetButton || !variantContainer.contains(targetButton)) {
        return;
      }
      const group = targetButton.closest('.variant-option-group');
      if (!group) return;
      const buttonsInGroup = group.querySelectorAll('.variant-button');
      buttonsInGroup.forEach(btn => {
        btn.classList.remove('active');
        btn.setAttribute('aria-checked', 'false');
      });
      targetButton.classList.add('active');
      targetButton.setAttribute('aria-checked', 'true');
      updateUIForVariant();
    });
    
    // Initialize on load - this will filter images based on default selected color
    updateUIForVariant();
    
    return {
      setProduct(newProduct, options = {}) {
        const overrides = options.selectionOverrides || {
          [colorOptionIndex]: options.colorOverride || (newProduct && newProduct.color_label) || null
        };
        return setActiveProductContext(newProduct, {
          variantMeta: options.variantMeta,
          selectionOverrides: overrides,
          sourceProduct: options.sourceProduct || newProduct,
          forceImageUpdate: options.forceImageUpdate,
          isInitialLoad: options.isInitialLoad || false
        });
      },
      getActiveProduct() {
        return activeProduct;
      }
    };
  }
  
  function initLinkedColorProducts(container, productId, variantController, linkedProducts, initialProduct) {
    if (!variantController || !Array.isArray(linkedProducts) || linkedProducts.length === 0) {
      return;
    }
    
    const swatchWrapper = container.querySelector('[data-color-swatches]');
    if (!swatchWrapper) return;
    const hiddenButtonsWrapper = container.querySelector('[data-color-hidden-buttons]');
    const linkedMap = {};

    // Gallery controls (fade in after gallery is ready)
    const galleryControls = container.querySelector('.gallery-controls');

    // Elements to animate on product switch
    const infoCol = container.querySelector('.product-information-col');
    const gallery = container.querySelector('.product-gallery');
    const desktopKey = container.querySelector('.product-key.desktop-discription');
    const mobileKey = container.querySelector('.product-key.mobile-discription');
    const fadeTargets = [infoCol, gallery, desktopKey, mobileKey].filter(Boolean);
    const fadeDuration = 500;
    
    linkedProducts.forEach(productData => {
      if (productData && productData.id) {
        linkedMap[String(productData.id)] = productData;
      }
    });
    
    let activeId = container.dataset.activeProductId;
    if (!activeId || !linkedMap[activeId]) {
      activeId = initialProduct && initialProduct.id
        ? String(initialProduct.id)
        : (linkedProducts[0] ? String(linkedProducts[0].id) : null);
    }
    if (activeId) {
      if (!linkedMap[activeId] && initialProduct) {
        linkedMap[activeId] = initialProduct;
      }
      container.dataset.activeProductId = activeId;
    }
    
    const updateHiddenButtons = (targetId, colorLabel) => {
      if (!hiddenButtonsWrapper) return;
      hiddenButtonsWrapper.querySelectorAll('.variant-button').forEach(btn => {
        if (btn.getAttribute('data-color-product-id') === targetId) {
          btn.classList.add('active');
          btn.setAttribute('aria-checked', 'true');
          if (colorLabel) {
            btn.setAttribute('data-value', colorLabel);
          }
        } else {
          btn.classList.remove('active');
          btn.setAttribute('aria-checked', 'false');
        }
      });
    };
    
    const updateSwatchState = (targetId) => {
      swatchWrapper.querySelectorAll('.color-product-swatch').forEach(btn => {
        const isMatch = btn.getAttribute('data-color-product-id') === targetId;
        btn.classList.toggle('is-active', isMatch);
        btn.classList.toggle('active', isMatch);
        btn.setAttribute('aria-checked', isMatch ? 'true' : 'false');
      });
    };
    
    const stripHtml = (html) => {
      if (!html) return '';
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      return (tmp.textContent || tmp.innerText || '').trim();
    };

    const truncateText = (text, maxLength = 145) => {
      if (!text) return '';
      if (text.length <= maxLength) return text;
      return `${text.slice(0, maxLength - 1).trim()}.`;
    };

    const updateProductContent = (productData) => {
      if (!productData) return;
      const titleEl = container.querySelector(`#product-title-${productId}`);
      if (titleEl) titleEl.textContent = productData.title || '';
      const descEl = container.querySelector(`#product-description-${productId}`);
      if (descEl) {
          const rawDescription = productData.description_short || productData.description || '';
          const plainText = stripHtml(rawDescription);
          descEl.textContent = (plainText);
      }
      const colorLabelEl = container.querySelector('.home-page-collection-section__color-label');
      if (colorLabelEl) colorLabelEl.textContent = productData.color_label || '';
      const featureEls = container.querySelectorAll('.product-fetures-description');
      featureEls.forEach(el => {
        el.innerHTML = productData.key_benefits || '';
      });
    };
    
    const switchToProduct = (productData, isInitialLoad = false) => {
      if (!productData) return;
      const targetId = String(productData.id);
      container.dataset.activeProductId = targetId;
      updateSwatchState(targetId);
      updateHiddenButtons(targetId, productData.color_label);
      
      const performUpdate = () => {
        updateProductContent(productData);
        return variantController.setProduct(productData, {
          variantMeta: buildVariantMetaFromProduct(productData),
          colorOverride: productData.color_label,
          forceImageUpdate: true,
          sourceProduct: productData,
          isInitialLoad: isInitialLoad
        });
      };

      // For initial load, avoid content fade to prevent flashes
      if (isInitialLoad || !fadeTargets.length) {
        const result = performUpdate();

        // Add visible class immediately for initial load
        fadeTargets.forEach(el => {
          el.classList.add('fade-content-visible');
        });

        // Show gallery controls at the same time as gallery/images are ready
        if (galleryControls) {
          const showControls = () => {
            galleryControls.classList.add('gallery-controls--visible');
          };
          if (result && typeof result.then === 'function') {
            result.then(showControls);
          } else {
            showControls();
          }
        }

        return;
      }

      // Fade out gallery controls immediately (0ms)
      if (galleryControls) {
        galleryControls.classList.remove('gallery-controls--visible');
      }

      // Remove visible class to hide content (opacity: 0)
      fadeTargets.forEach(el => {
        el.classList.remove('fade-content-visible');
      });

      // Update content immediately
      const result = performUpdate();

      // Wait for images to load before fading in
      const waitForImagesToLoad = () => {
        return new Promise((resolve) => {
          const mainSwiperEl = gallery?.querySelector(`.mySwiper-${productId}`);
          if (!mainSwiperEl) {
            resolve();
            return;
          }
          const images = mainSwiperEl.querySelectorAll('img');
          if (images.length === 0) {
            resolve();
            return;
          }
          let loadedCount = 0;
          const checkComplete = () => {
            loadedCount++;
            if (loadedCount >= images.length) {
              // Wait for layout to settle
              requestAnimationFrame(() => {
                requestAnimationFrame(resolve);
              });
            }
          };
          images.forEach(img => {
            if (img.complete && img.naturalHeight > 0) {
              checkComplete();
            } else {
              img.addEventListener('load', checkComplete, { once: true });
              img.addEventListener('error', checkComplete, { once: true });
            }
          });
          // Timeout fallback after 3 seconds
          setTimeout(resolve, 3000);
        });
      };

      // Once product + gallery updated, wait for images, then fade content in
      const afterUpdate = async () => {
        // Wait for images to load
        await waitForImagesToLoad();
        
        // Small delay to ensure everything is rendered
       // await new Promise(resolve => setTimeout(resolve, 0));
        
        // Trigger smooth fade-in animation by adding visible class
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            fadeTargets.forEach(el => {
              el.classList.add('fade-content-visible');
            });
          });
        });

        // Show gallery controls at the same time as other content
        if (galleryControls) {
          galleryControls.classList.add('gallery-controls--visible');
        }
      };

      if (result && typeof result.then === 'function') {
        result.then(afterUpdate);
      } else {
        afterUpdate();
      }
    };
    
    const initialProductState = (activeId && linkedMap[activeId]) || initialProduct || linkedProducts[0];
    if (initialProductState) {
      switchToProduct(initialProductState, true); // Pass true for initial load
    }
    
    swatchWrapper.addEventListener('click', (event) => {
      const swatch = event.target.closest('.color-product-swatch');
      if (!swatch) return;
      const targetId = swatch.getAttribute('data-color-product-id');
      if (!targetId || container.dataset.activeProductId === targetId) return;
      const nextProduct = linkedMap[targetId];
      if (!nextProduct) return;
      switchToProduct(nextProduct);
    });
  }

  // Initialize everything
  initTabs();
  initOuterSliders();
  initAllProductDisplays();
});

